<template>
  <div class="operations-box">
    <span
      v-for="(item, index) in getBtns"
      class="btn"
      :key="index"
      @click.stop="handleClick(item)"
    >{{item.value}}</span>
  </div>
</template>

<script>
export default {
  name: 'operations',
  props: {
    row: [Array, Object],
    item: [Array, Object]
  },
  computed: {
    getBtns () {
      return this.item.typeOptions
    }
  },
  methods: {
    handleClick (item) {
      this.$emit('onOperations', item.key)
    }
  }
}
</script>

<style lang="scss" scoped>
  .operations-box{
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;

    .btn{
      margin-right: 10px;
      color: #409EFF;
      font-weight: 500;
      cursor: pointer;
      border-bottom: 1px solid rgba(0,0,0,0);

      &:hover {
        border-bottom: 1px solid #409EFF;
      }

      &:last-child{
        margin-right: 0px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/IMTable/components/operations/index.vue